"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var amsMessagesWrapper = function amsMessagesWrapper(Component) {
  return function (_ref) {
    var messages = _ref.messages,
        viewMessages = _ref.viewMessages,
        deleteMessages = _ref.deleteMessages,
        props = _objectWithoutProperties(_ref, ["messages", "viewMessages", "deleteMessages"]);

    var _React$useMemo = _react["default"].useMemo(function () {
      return messages.reduce(function (a, c) {
        if (c.deleted) {
          a[1].push(c);
        } else {
          a[0].push(c);
        }

        return a;
      }, [[], []]);
    }, [messages]),
        _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
        undeleted = _React$useMemo2[0],
        deleted = _React$useMemo2[1];

    var _React$useState = _react["default"].useState([]),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        selected = _React$useState2[0],
        setSelected = _React$useState2[1];

    var toggleSelected = _react["default"].useCallback(function (mId) {
      setSelected(function (prev) {
        if (prev.includes(mId)) {
          return prev.filter(function (id) {
            return id !== mId;
          });
        }

        return [].concat(_toConsumableArray(prev), [mId]);
      });
    }, []);

    var toggleAll = _react["default"].useCallback(function () {
      setSelected(function (prev) {
        if (prev.length) {
          return [];
        }

        return messages.map(function (msg) {
          return msg.id;
        });
      });
    }, [messages]);

    var viewSelected = _react["default"].useCallback(function () {
      viewMessages(selected);
    }, [viewMessages, selected]);

    var deleteSelected = _react["default"].useCallback(function () {
      setSelected([]);
      deleteMessages(selected);
    }, [deleteMessages, selected]);

    return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, {
      toggleSelected: toggleSelected,
      viewMessages: viewMessages,
      viewSelected: viewSelected,
      deleteMessages: deleteMessages,
      deleteSelected: deleteSelected,
      toggleAll: toggleAll,
      selected: selected,
      messages: undeleted,
      deleted: deleted
    }));
  };
};

var _default = amsMessagesWrapper;
exports["default"] = _default;